import React, { useState, useMemo, useRef } from 'react';
import { FaHeartbeat, FaHeart, FaTint, FaUserCircle } from 'react-icons/fa';
import ResultRow    from './results/ResultRow';
import MetricDetail from './home/MetricDetail';
import logoPng      from '../assets/truscan_logo.png';
import './results/ResultsPage.scss';

export default function ResultsPage() {
  /* ---------- mock datasets (replace with real API) ---------- */
  const vitals = useMemo(() => ([
    { id: 1, label: 'Breathing Rate', icon: <FaHeartbeat />, value: '19',     status: 'satisfactory', percent: 50 },
    { id: 2, label: 'Blood Sugar',    icon: <FaHeart />,     value: '168',    status: 'poor',         percent: 40 },
    { id: 3, label: 'SpO₂',           icon: <FaTint />,      value: '95',     status: 'good',         percent: 80 },
    { id: 4, label: 'Cholesterol',    icon: <FaHeart />,     value: '198.0',  status: 'poor',         percent: 20 },
    { id: 5, label: 'Heart Rate',     icon: <FaHeartbeat />, value: '76',     status: 'good',         percent: 75 },
    { id: 6, label: 'Blood Pressure', icon: <FaHeart />,     value: '118/83', status: 'good',         percent: 70 }
  ]), []);

  const vitamins = useMemo(() => ([
    { id: 1, label: 'Vitamin B12', icon: <FaHeart />, value: '62', status: 'good',         percent: 72 },
    { id: 2, label: 'Vitamin B3', icon: <FaHeart />, value: '48', status: 'satisfactory', percent: 50 },
    { id: 3, label: 'Vitamin E',  icon: <FaHeart />, value: '66', status: 'good',         percent: 80 }
  ]), []);

  const wellness = []; /* fill later */

  /* ---------- state ---------- */
  const [tab, setTab]             = useState('vitals');
  const [selected, setSelected]   = useState(null);

  const items = tab === 'vitals'   ? vitals
              : tab === 'vitamins' ? vitamins
              : wellness;

  /* ---------- scroll-to-top ref ---------- */
  const containerRef = useRef(null);

  const handleRowClick = item => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
    setSelected(item);
  };

  /* ---------- helpers ---------- */
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);

  /* ---------- render ---------- */
  return (
    <div className="results-page" ref={containerRef}>
      {/* top bar */}
      <header className="top-bar">
        <img src={logoPng} alt="logo" className="logo" />
        <FaUserCircle className="avatar" />
      </header>

      {/* inner tabs */}
      <div className="tabs-scroll">
        {['vitals', 'vitamins', 'wellness'].map(t => (
          <button
            key={t}
            className={`tab ${t === tab ? 'active' : ''}`}
            onClick={() => setTab(t)}
          >
            {cap(t)}
          </button>
        ))}
      </div>

      {/* timestamp */}
      <div className="timestamp">
        <span>2 days ago</span>
        <span>08/05/2025 10:16 AM</span>
      </div>

      {/* <h3 className="section-title">{tab.toUpperCase()}</h3> */}

      {/* list */}
      <section className="list">
        {items.map(it => (
          <ResultRow key={it.id} data={it} onClick={handleRowClick} />
        ))}
      </section>

      {/* vitamin-only button */}
      {/* {tab === 'vitamins' && (
        <button className="full-report">Send full report</button>
      )} */}

      {/* overlay */}
      {selected && (
        <MetricDetail
          data={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}
